import boletaApi from "./boletaApi";

export const updateEstadoPago = async (body) => {
  try {
    return await boletaApi.post("/updateInvoicePago", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
